const WORDS_PER_MINUTE = 100;

export const estimateReadTime = (text: string): number =>
    Math.round(text.split(/\s+/g).length / WORDS_PER_MINUTE);
